<template>
  <div class="ap-step-item" :class="['ap-step-item--' + (isActive ? 'process' : currentStatus)]">
    <div role="tab" :aria-expanded="isActive" :aria-controls="'ap-step-content-' + name">
      <div class="ap-step-item__header" :id="'ap-step-head-' + name">
        <slot name="title">{{ title }}</slot>
        <slot name="edit">
          <div class="box-hd-close">
            <button type="button" class="ap-step-item__arrow" @click="onExpandedClick">
              <i class="icon-edit"></i>
            </button>
          </div>
        </slot>
      </div>
    </div>
    <transition name="a-step-transition" v-on="slider">
      <div role="tabpanel" :id="'ap-step-content-' + name" v-show="isActive" :aria-labelledby="'ap-step-head-' + name"
        class="ap-step-item__wrap">
        <div class="ap-step-item__content">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject } from 'vue'
import { useSlide, type DoActionType } from '../hooks'
import { stepGroupContextKey } from '../step-group'
import { stepItemProps, type StepStatus } from './step-item'

export default defineComponent({
  props: stepItemProps,
  emits: ['update:modelValue', 'before-enter', 'after-enter', 'before-leave', 'after-leave'],
  setup (props, { emit }) {
    const parent = inject(stepGroupContextKey)

    const doAction = (action: DoActionType, value: string | number) => {
      emit(action)
      if (parent) {
        parent.doAction(action, value)
      }
    }

    const slider = useSlide((action) => {
      doAction(action, props.name)
    })

    const currentStatus = computed({
      get () {
        return props.modelValue
      },
      set (val: StepStatus) {
        emit('update:modelValue', val)
      }
    })

    const isActive = computed(() => {
      return currentStatus.value === 'process'
    })

    const onExpandedClick = () => {
      // currentStatus.value = 'process'
      if (parent) {
        parent.changeEvent(props.name)
      }
    }
    return {
      slider,
      currentStatus,
      isActive,
      onExpandedClick
    }
  }
})
</script>
<style lang="less">
.ap-step-item {
  display: block;
  border: 1px solid #d7d7d7;
  margin-bottom: 15px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 29px;
    line-height: 29px;
    padding-left: 10px;
    padding-right: 10px;
    border: 0;
    border-radius: 0;
    font-size: 15px;
    font-weight: 600;
    background: #ededed;
    color: #4e4e4e;
    position: relative;
  }

  .box-hd-close {
    width: 54px;
    height: 24px;
    border: 1px solid #ccc;
    border-radius: 3px;
    text-align: center;
    float: right;
    background: #fff;
    cursor: pointer;
    display: none;
  }

  &__arrow {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
    outline: none;
    border: none;
    background: url(https://img66.anypromo.com/frontimg/2018/checkout/edit.png) no-repeat;
  }

  &--wait &__header .box-hd-close {
    display: none;
  }

  &--process &__header {
    background: #ec651c;
    color: #fff;
  }

  &--process &__header .box-hd-close {
    display: none;
  }

  &--finish &__header .box-hd-close {
    display: block;
  }

  &--disabled {}

  &__wrap {
    will-change: height;
    background-color: #fff;
    box-sizing: border-box;
  }

  &__content {
    display: block;
  }
}
</style>
